import {
  MapObjectAction,
  ICybersecurityInfoState,
  CybersecurityMapActionsEnum,
} from "./types";

const initialState: ICybersecurityInfoState = {
  isObjectsLoading: false,
  params: {},
  hash_ids: [],
  selectedObject: null,
  count: 0,
  results: [],
  next: null,
};

export default function cybersecurityReducer(
  state = initialState,
  action: MapObjectAction
) {
  switch (action.type) {
    case CybersecurityMapActionsEnum.SET_IS_CYBERSECURITY_LOADING:
      return { ...state, isObjectsLoading: action.payload };
    case CybersecurityMapActionsEnum.SET_SELECTED_CYBERSECURITY_OBJECT:
      return { ...state, selectedObject: action.payload };

    case CybersecurityMapActionsEnum.SET_MAP_CYBERSECURITY_LIST:
      return { ...state, ...action.payload };

    default:
      return state;
  }
}
